export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/Login/index.vue'),
        meta: {
            guest: true
        }
    },
    {
        path: '/login/redirect-cobas-plus',
        name: 'loginRedirectCobasPlus',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/LoginCobasPlus/index.vue'),
        meta: {
            guest: true
        }
    },
    {
        path: '/login/admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/Login/Admin/index.vue'),
        meta: {
            guest: true
        }
    },
    {
        path: '/login/password-request',
        name: 'passwordRequest',
        component: () =>
            import(/* webpackChunkName: "Login" */ '@/views/Login/PasswordReset/index.vue'),
        meta: {
            guest: true
        }
    },
    {
        path: '/login/new-password',
        name: 'newPassword',
        component: () =>
            import(/* webpackChunkName: "Login" */ '@/views/Login/NewPassword/index.vue'),
        props: route => ({ uuid_user: route.query.uuid_user }),
        meta: {
            guest: true
        }
    },
    {
        path: '/login/ciber-security',
        name: 'logincibersecurity',
        component: () =>
            import(/* webpackChunkName: "CiberSecurity" */ '@/views/CiberSecurity/index.vue'),
        meta: {
            guest: true
        }
    }
];
